import { v4 as uuidv4 } from 'uuid'

export const getInitialCollectionsCarouselItemData = () => ({
  caption: '',
  cmsShowroomPage: null,
  previewImageAttachment: {},
  profileImageAttachment: null,
  clientId: uuidv4(),
})
